module.exports = __webpack_public_path__ + "img/group-avatar.f23a43b4.svg";